import SelectProduct from './selectProduct.vue';
import TableSelect from './tableSelect.vue';

export {
  SelectProduct,
  TableSelect,
};
